export function storeInvitation(queryParams) {
  if (localStorage.getItem('invitation_code') != null) {
    window.location = '/accept-invitation';
  } else {
    let data = JSON.parse(atob(queryParams.invitation));
    if (data) {
      localStorage.setItem('invitation_code', data.code);
      if (data.is_user) {
        window.location = '/accept-invitation';
      } else {
        window.location = '/register';
      }
    } else {
      window.location = '/';
    }
  }
}
